export enum BottomStripEvents {
	SupportClicked = 'Bottom Strip: Support clicked',
}

export enum BottomStripEventKeys {
	Type = 'type',
}

export enum BottomStripSupportType {
	Pylon = 'pylon',
	AddCard = 'add_card',
}
